import { useWorkspaceStore } from '@modules/settings/workspace/stores/workspace.store'

import { clearWorkspaceScopedClientStores } from './clearWorkspaceScopedClientStores'

export function clearClientStoresBeforeWorkspaceContextChange(): void {
  clearWorkspaceScopedClientStores()
  useWorkspaceStore.getState().clearScopedMemberData()
}
